/**
 * @generated SignedSource<<0646ee5fa0792c0b65810c5907309f97>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreditSubscriptionStatus = "ACTIVE" | "CANCELED" | "INCOMPLETE" | "INCOMPLETE_EXPIRED" | "PAST_DUE" | "PAUSED" | "TRIALING" | "UNPAID" | "%future added value";
export type creditsOneDeliveryQuery$variables = Record<PropertyKey, never>;
export type creditsOneDeliveryQuery$data = {
  readonly creditBalance: {
    readonly available: number;
    readonly expiring: number;
    readonly nextExpiryAt: any | null | undefined;
  };
  readonly creditOffers: ReadonlyArray<{
    readonly credits: number;
    readonly description: string | null | undefined;
    readonly features: ReadonlyArray<string>;
    readonly id: string;
    readonly maxPerUser: number | null | undefined;
    readonly priceCents: number;
    readonly purchasable: boolean;
    readonly title: string;
  }>;
  readonly creditPlans: ReadonlyArray<{
    readonly credits: number;
    readonly description: string | null | undefined;
    readonly features: ReadonlyArray<string>;
    readonly id: string;
    readonly priceCents: number;
    readonly title: string;
  }>;
  readonly creditSubscription: {
    readonly cancelAtPeriodEnd: boolean;
    readonly currentPeriodEnd: any | null | undefined;
    readonly id: string;
    readonly plan: {
      readonly active: boolean;
      readonly credits: number;
      readonly id: string;
      readonly priceCents: number;
      readonly title: string;
    };
    readonly status: CreditSubscriptionStatus;
  } | null | undefined;
};
export type creditsOneDeliveryQuery = {
  response: creditsOneDeliveryQuery$data;
  variables: creditsOneDeliveryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "credits",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceCents",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "features",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CreditBalance",
    "kind": "LinkedField",
    "name": "creditBalance",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "available",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expiring",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nextExpiryAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CreditSubscription",
    "kind": "LinkedField",
    "name": "creditSubscription",
    "plural": false,
    "selections": [
      (v0/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cancelAtPeriodEnd",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentPeriodEnd",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CreditPlan",
        "kind": "LinkedField",
        "name": "plan",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CreditPlan",
    "kind": "LinkedField",
    "name": "creditPlans",
    "plural": true,
    "selections": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CreditOffer",
    "kind": "LinkedField",
    "name": "creditOffers",
    "plural": true,
    "selections": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxPerUser",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "purchasable",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "creditsOneDeliveryQuery",
    "selections": (v6/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "creditsOneDeliveryQuery",
    "selections": (v6/*:: as any*/)
  },
  "params": {
    "cacheID": "284ea35f3d3ef38fb442b1cafd091a3c",
    "id": null,
    "metadata": {},
    "name": "creditsOneDeliveryQuery",
    "operationKind": "query",
    "text": "query creditsOneDeliveryQuery {\n  creditBalance {\n    available\n    expiring\n    nextExpiryAt\n  }\n  creditSubscription {\n    id\n    status\n    cancelAtPeriodEnd\n    currentPeriodEnd\n    plan {\n      id\n      title\n      credits\n      priceCents\n      active\n    }\n  }\n  creditPlans {\n    id\n    title\n    description\n    features\n    credits\n    priceCents\n  }\n  creditOffers {\n    id\n    title\n    description\n    features\n    credits\n    priceCents\n    maxPerUser\n    purchasable\n  }\n}\n"
  }
};
})();

(node as any).hash = "7a9bc8d30bd045cd6e44e77d62f5fb33";

export default node;
